import Model from '@/models/Model'

export default class WhDispatchRequestBatch extends Model {
    resource() {
        return 'wh_dispatch_request_batch'
    }
}
